<div class="loginMain">
  <div class="login">
    <h1 style="color: #5baf1e; margin-top: 10px" class="text-center">
      Institute for Training in Ministry
    </h1>
    <div class="logo text-center">
      <img
        src="./assets/images/logo.png"
        class="img-fluid"
        style="width: 80px"
      />
    </div>

    <ng-container *ngIf="is_form">
      <div class="loginBox">
        <form *ngIf="forgotPasswordForm" [formGroup]="forgotPasswordForm">
          <h1 class="form-title">Forgot Password</h1>
          <div class="form-group">
            <label for="exampleInputEmail1">Email address</label>
            <input
              type="email"
              class="form-control input"
              name="email"
              formControlName="email"
              placeholder="Email address"
              [class.is-invalid]="isControlInvalid('email')"
              [class.is-valid]="isControlValid('email')"
            />
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError('required', 'email')"
            >
              This field is required
            </h5>
          </div>
          <div class="form-group">
            <a [routerLink]="['/session']" class="linkSecondary">Login?</a>
          </div>
          <button
            type="submit"
            (click)="save()"
            class="btn btn-block btnSecondary"
          >
            Send Verification Code
          </button>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="is_confrim_code">
      <div class="loginBox">
        <form
          name="login"
          *ngIf="ConfirmCodeForm"
          [formGroup]="ConfirmCodeForm"
        >
          <h1 class="form-title">Verify OTP</h1>
          <div class="form-group">
            <label for="exampleInputEmail1">Email address</label>
            <input
              type="email"
              class="form-control input"
              name="email"
              formControlName="email"
              placeholder="Email address"
            />
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Enter Verification Code</label>
            <input
              type="text"
              name="otp"
              class="form-control input"
              formControlName="otp"
              placeholder="OTP"
            />
          </div>
          <button
            type="submit"
            (click)="save2()"
            class="btn btn-block btnSecondary"
          >
            Submit
          </button>

          <button
            type="submit"
            (click)="save()"
            class="btn btn-block btnSecondary"
          >
            Resend OTP
          </button>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="is_set_password">
      <div class="loginBox">
        <form
          name="login"
          *ngIf="SetPasswordForm"
          [formGroup]="SetPasswordForm"
        >
          <h1 class="form-title">Set New Password</h1>
          <div class="form-group">
            <label for="exampleInputEmail1">Email address</label>
            <input
              type="email"
              class="form-control input"
              name="email"
              formControlName="email"
              placeholder="Email address"
            />
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Password</label>
            <input
              type="password"
              name="password"
              class="form-control input"
              formControlName="NewPassword"
              [class.is-invalid]="isControlInvalid1('NewPassword')"
              placeholder="New Password"
              [class.is-valid]="isControlValid1('NewPassword')"
              autocomplete="off"
            />
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError1('required', 'NewPassword')"
            >
              This field is required
            </h5>
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Confrim Password</label>
            <input
              type="password"
              name="password"
              class="form-control input"
              placeholder="Confirm Password"
              formControlName="confirm_password"
              [class.is-invalid]="
                isControlInvalid1('confirm_password') || isMatch
              "
              [class.is-valid]="isControlValid1('confirm_password')"
              autocomplete="off"
            />
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError1('required', 'confirm_password')"
            >
              This field is required
            </h5>

            <h5 class="invalid-feedback" *ngIf="isMatch">
              Confirm Password must be same as Password
            </h5>
          </div>
          <button
            type="submit"
            (click)="save3()"
            class="btn btn-block btnSecondary"
          >
            Set Password
          </button>
        </form>
      </div>
    </ng-container>
  </div>
</div>
